/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Week_TitleInputs */

const en_us2_today_week_title = /** @type {(inputs: Today_Week_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your week`)
};

const pt_br2_today_week_title = /** @type {(inputs: Today_Week_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua semana`)
};

const es_419_today_week_title = /** @type {(inputs: Today_Week_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu semana`)
};

const pt_pt2_today_week_title = /** @type {(inputs: Today_Week_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua semana`)
};

const fr_fr2_today_week_title = /** @type {(inputs: Today_Week_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta semaine`)
};

const de_de2_today_week_title = /** @type {(inputs: Today_Week_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Woche`)
};

const it_it2_today_week_title = /** @type {(inputs: Today_Week_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua settimana`)
};

/**
* | output |
* | --- |
* | "Your week" |
*
* @param {Today_Week_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_week_title = /** @type {((inputs?: Today_Week_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Week_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_week_title(inputs)
	if (locale === "es-419") return es_419_today_week_title(inputs)
	if (locale === "pt-PT") return pt_pt2_today_week_title(inputs)
	if (locale === "fr-FR") return fr_fr2_today_week_title(inputs)
	if (locale === "de-DE") return de_de2_today_week_title(inputs)
	if (locale === "it-IT") return it_it2_today_week_title(inputs)
	return en_us2_today_week_title(inputs)
});
export { today_week_title as "today.week_title" }